module.exports = __webpack_public_path__ + "media/standalone/full_access-8ffe9533.svg";